import { AddBox, Delete, Edit } from "@mui/icons-material";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Modal, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import axiosInstance from "../../../utils/axiosInstance";

const Members = () => {
    const [members, setMembers] = useState([
        {
            member_id: 0,
            name: '',
            email: '',
            phone: '',
            durations: '',
            height: '',
            size: '',
            weight: '',
            createdAt: '',
        }
    ]);
    const [member, setMember] = useState({
        member_id: 0,
        name: '',
        email: '',
        phone: '',
        durations: '',
        height: '',
        size: '',
        weight: '',
        password: '',
    })

    const [selectedMember, setSelectedMember] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const getMembersRef = useRef()

    const filteredMembers = members.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase())  || user.phone.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedMembers = filteredMembers.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        console.log(event)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Delete confirmation handlers
    const handleOpenDeleteModal = (member) => {
        setSelectedMember(member);
        setIsDeleteModalOpen(true);
    };

    const handleOpenEditModal = (member) => {
        setSelectedMember(member);
        setIsEditModalOpen(true);
    };

    const handleAddMember = async() => {
        setOpen(true);

        await axiosInstance.post(`membership/create`, member, {
                headers: { 'Content-Type': 'application/json' }
            }).then((response) => {
            setMessage(`Success, successfully added ${member.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getMembersRef.current) getMembersRef.current()
                setIsAddModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    const handleEditMember = async() => {
        setOpen(true);

        await axiosInstance.put(`membership/update/${selectedMember.member_id}`, selectedMember).then((response) => {
            setMessage(`Success, successfully edited ${selectedMember.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getMembersRef.current) getMembersRef.current()
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000)
        })
    }

    const handleDeleteMember = async() => {
        setOpen(true)
        
        await axiosInstance.delete(`membership/delete/${selectedMember.member_id}`).then((response) => {
            setMessage(`Success, successfully deleted ${selectedMember.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getMembersRef.current) getMembersRef.current()
                setIsDeleteModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage("No membership found")
            } else if(error.status === 400) {
                setMessage(error.response.error)
            } else {
                console.log(error)
            }

            setTimeout(() => {
                setOpen(false)
            }, 2000)
        })
    }

    useEffect(() => {
        const getMembers = async () => {
            await axiosInstance.get(`membership/all`).then((response) => {
                setMembers(response.data.data);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No memberships found") {
                    setMembers([]);
                } else if(error.response && error.response.data.message !== "No memberships found") {
                    setMembers([]);
                    // console.error(error.response.data)
                } else {
                    setMembers([]);
                    // console.log(error);
                }
            });
        }

        getMembersRef.current = getMembers;

        getMembers();
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage members</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Member</Button></div>
            </div>
            <br />

            <div className="p-4">
                <TextField label="Search for a member by name, email, phone" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Height</TableCell>
                                <TableCell>Size</TableCell>
                                <TableCell>Weight</TableCell>
                                <TableCell>Created At</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedMembers.map((member, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{member.name}</TableCell>
                                    <TableCell>{member.email}</TableCell>
                                    <TableCell>{member.phone}</TableCell>
                                    <TableCell>{member.durations} Months</TableCell>
                                    <TableCell>{member.height} ft</TableCell>
                                    <TableCell>{member.size}</TableCell>
                                    <TableCell>{member.weight} kg</TableCell>
                                    <TableCell>{member.createdAt.slice(0,10)}</TableCell>
                                    {/* <TableCell>{dateFormat(member.createdAt)}</TableCell> */}
                                    <TableCell className="flex gap-2">
                                        {/* <RemoveRedEye color="success" className="cursor-pointer" /> */}
                                        <Edit color="primary" onClick={() => handleOpenEditModal(member)} className="cursor-pointer" />
                                        <Delete color="error" onClick={() => handleOpenDeleteModal(member)} className="cursor-pointer" />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredMembers.length === 0 && <TableRow><TableCell colSpan={10} className="text-center">No member found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredMembers.length]}
                        component="div"
                        count={filteredMembers.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the member named "
                        {selectedMember.name ? selectedMember.name : "Anonymus"}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteMember} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit member Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Edit member</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={selectedMember.name} onChange={(e) => setSelectedMember((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Enter name" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedMember.email} onChange={(e) => setSelectedMember((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Enter email" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedMember.phone} onChange={(e) => setSelectedMember((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Enter phone" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedMember.durations} onChange={(e) => setSelectedMember((prev) => ({ ...prev, durations: e.target.value }))} type="number" label="Enter duration in months e.g 4" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedMember.height} onChange={(e) => setSelectedMember((prev) => ({ ...prev, height: e.target.value }))} type="number" label="Enter height e.g 3.4" style={{ marginBottom: 10 }} />
                        <FormControl fullWidth style={{ marginBottom: 15 }}>
                            <InputLabel>Select size</InputLabel>
                            <Select label="Select size" value={selectedMember.size} onChange={(e) => setSelectedMember((prev) => ({ ...prev, size: e.target.value }))}>
                                <MenuItem value="S">
                                    S
                                </MenuItem>
                                <MenuItem value="M">
                                    M
                                </MenuItem>
                                <MenuItem value="L">
                                    L
                                </MenuItem>
                                <MenuItem value="XL">
                                    XL
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField variant="outlined" fullWidth value={selectedMember.weight} onChange={(e) => setSelectedMember((prev) => ({ ...prev, weight: e.target.value }))} type="number" label="Enter weight e.g. 4" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" onClick={handleEditMember} variant="outlined" fullWidth>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Member Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Add Member</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={member.name} onChange={(e) => setMember((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Enter name" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={member.email} onChange={(e) => setMember((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Enter email" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={member.phone} onChange={(e) => setMember((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Enter phone" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={member.durations} onChange={(e) => setMember((prev) => ({ ...prev, durations: e.target.value }))} type="number" label="Enter duration in months e.g 4" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={member.height} onChange={(e) => setMember((prev) => ({ ...prev, height: e.target.value }))} type="number" label="Enter height e.g. 4" style={{ marginBottom: 10 }} />
                        <FormControl fullWidth style={{ marginBottom: 15 }}>
                            <InputLabel>Select size</InputLabel>
                            <Select label="Select size" value={member.size} onChange={(e) => setMember((prev) => ({ ...prev, size: e.target.value }))}>
                                <MenuItem value="S">
                                    S
                                </MenuItem>
                                <MenuItem value="M">
                                    M
                                </MenuItem>
                                <MenuItem value="L">
                                    L
                                </MenuItem>
                                <MenuItem value="XL">
                                    XL
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField variant="outlined" fullWidth value={member.weight} onChange={(e) => setMember((prev) => ({ ...prev, weight: e.target.value }))} type="number" label="Enter weight e.g 36" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={member.password} onChange={(e) => setMember((prev) => ({ ...prev, password: e.target.value }))} type="password" label="Enter password" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" onClick={handleAddMember} variant="outlined" fullWidth>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Members